import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLollipop16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconLollipop16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12 11V6a4 4 0 0 0-8 0v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1m-7 2h1.5v.5a1.5 1.5 0 0 0 3 0V13H11a2 2 0 0 0 2-2V6A5 5 0 0 0 3 6v5a2 2 0 0 0 2 2m2.5.5V13h1v.5a.5.5 0 0 1-1 0m-1-9A.5.5 0 0 1 7 5v5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5m3 0a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLollipop16);
